/**
 * Decides whether authenticated analytics (GA PAGE_VIEW, backend events, click/error tracking) may
 * fire. GoKollab tracks login-independently, so it is always allowed. Everywhere else a known
 * contactId is required — the current-user profile is the source of truth (so the gate opens the
 * moment the profile loads, independent of any navigation), with the navigation-derived analytics
 * context as a fallback. Pure so the plugin's gate can be unit-tested without the Nuxt runtime.
 */
export function canSendAuthenticatedAnalytics(
  isGokollabApp: boolean,
  profileContactId: string | null | undefined,
  contextContactId: string | null | undefined
): boolean {
  if (isGokollabApp) return true
  return Boolean(profileContactId || contextContactId)
}
